module.exports = __webpack_public_path__ + "img/07_NSC_iPad_P.e6afa116.jpg";